var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5 20.1666C16.7927 20.1666 21.0833 16.0625 21.0833 10.9999C21.0833 5.93731 16.7927 1.83325 11.5 1.83325C6.20726 1.83325 1.91666 5.93731 1.91666 10.9999C1.91666 16.0625 6.20726 20.1666 11.5 20.1666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 10.3124H12.2187V7.33325C12.2187 6.95742 11.8929 6.64575 11.5 6.64575C11.1071 6.64575 10.7812 6.95742 10.7812 7.33325V10.3124H7.66666C7.27374 10.3124 6.94791 10.6241 6.94791 10.9999C6.94791 11.3758 7.27374 11.6874 7.66666 11.6874H10.7812V14.6666C10.7812 15.0424 11.1071 15.3541 11.5 15.3541C11.8929 15.3541 12.2187 15.0424 12.2187 14.6666V11.6874H15.3333C15.7262 11.6874 16.0521 11.3758 16.0521 10.9999C16.0521 10.6241 15.7262 10.3124 15.3333 10.3124Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.32183e80a6bcc68781b44fc5de98ffd9.svg";
export { ForwardRef as ReactComponent };